import { Text } from '../../constants/TextConstants'

export const NAV_ITEMS = [
  {
    label: Text.ViewProfile,
    icon: 'identification-card',
    action: '/',
    selectable: true,
    key: 'view'
  },
  {
    label: Text.Edit,
    icon: 'pencil-simple-line',
    action: '/edit',
    selectable: true,
    key: 'edit'
  },
  {
    label: Text.Audit,
    icon: 'notebook',
    action: '/audit',
    selectable: true,
    key: 'audit'
  },
  {
    label: Text.Profiles,
    icon: 'users',
    action: '/profiles',
    selectable: true,
    key: 'profiles',
    showCondition: true
  },
  {
    label: Text.RolesPermissions,
    icon: 'user-list',
    action: '/roles-assignment',
    selectable: true,
    key: 'roles',
    showCondition: false
  },
  {
    label: Text.ListManagement,
    icon: 'list-bullets',
    action: '',
    selectable: true,
    key: 'list-management',
    showCondition: false,
    children: [
      {
        label: Text.SpokenLanguages,
        action: '/languages',
        selectable: true,
        key: 'spoken-languages',
        children: [
          {
            label: Text.Languages,
            action: '/languages',
            selectable: true,
            key: 'languages'
          },
          {
            label: Text.Levels,
            action: '/language-level',
            selectable: true,
            key: 'language-level'
          }
        ]
      },
      {
        label: Text.EducationBackgroundDegreeTitle,
        action: '/educational-background',
        selectable: true,
        key: 'educational-background'
      },
      {
        label: Text.Certifications,
        action: '/certifications',
        selectable: true,
        key: 'certifications'
      },
      {
        label: Text.IndustrySectors,
        action: '/industry-sector',
        selectable: true,
        key: 'industry-sector'
      },
      {
        label: Text.Domains,
        action: '/industry-verticals',
        selectable: true,
        key: 'industry-verticals'
      },
      {
        label: Text.ProgrammingLanguages,
        action: '/programming-languages',
        selectable: true,
        key: 'programming-languages'
      },
      {
        label: 'Databases',
        action: '/databases',
        selectable: true,
        key: 'databases'
      },
      {
        label: Text.Frameworks,
        action: '/tools-techniques',
        selectable: true,
        key: 'tools-techniques'
      },
      {
        label: Text.TechnicalSkills,
        action: '/technical-skills',
        selectable: true,
        key: 'technical-skills'
      },
      {
        label: Text.SoftSkills,
        action: '/soft-skills',
        selectable: true,
        key: 'soft-skills'
      },
      {
        label: Text.Hobbies,
        action: '/hobbies',
        selectable: true,
        key: 'hobbies'
      },
      {
        label: Text.TechLevels,
        action: '/technical-levels',
        selectable: true,
        key: 'technical-levels'
      }
    ]
  }
]
